import {
  Autocomplete,
  MenuItem,
  Select,
  Stack,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  TableRow,
  TableCell,
  Button,
} from "@mui/material"
import { useState, useEffect, useContext } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { DatePicker } from "../ui/DateTimePickers"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import {
  createFee,
  findStudents,
  getPaymentModes,
  getStudentFee,
  searchAccountDepositor,
} from "../../api"
import UserContext from "../../contexts/user"
import { useSnackbar } from "notistack"
import TableComp from "../ui/TableComp"
import AddPayment from "../modals/AddPayment"
import AddFeeCompSingle from "../modals/AddFeeCompSingle"
import { DropzoneArea } from "mui-file-dropzone"
import { uploadInvoiceFile } from "../../utilities"

const AddFee = (props) => {
  const { user } = useContext(UserContext)
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [expenseAdded, setExpenseAdded] = useState(false)
  const [paymentModes, setPaymentModes] = useState([])
  const [inputValue, setInputValue] = useState("")
  const [students, setStudents] = useState([])
  const [studentsAcc, setStudentsAcc] = useState([])
  const [inputAccountValue, setInputAccountValue] = useState("")
  const [feeComps, setFeeComps] = useState([])
  const [totalFee, setTotalFee] = useState(0)
  const [addFeeCompModal, setAddFeeCompModal] = useState(false)
  const [expenses, setExpenses] = useState([])
  const [addExpenseModal, setAddExpenseModal] = useState(false)
  const [file, setFile] = useState(null)

  const [feeDetails, setFeeDetails] = useState({
    enrollmentNumber: "",
    amount: totalFee,
    currency: "INR",
    amountArray: [],
    modeOfPayment: "",
    payer: "",
    feeCollector: {
      id: user?.sub,
      label: user?.name,
    },
    generateInvoice: false,
    proof: "",
    name: "",
    year: "",
    semester: "",
  })

  const handleChange = (event) => {
    const { name, value } = event.target
    setFeeDetails({
      ...feeDetails,
      [name]: value,
    })
  }

  const [searching, setSearching] = useState(false)

  const searchStudentsAccounts = (value) => {
    searchAccountDepositor({
      keyword: value,
      paymentMode: feeDetails.modeOfPayment,
    })
      .then((res) =>
        setStudentsAcc(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching(false))
  }

  const handleSubmit = () => {
    setLoading(true)
    if (file) {
      uploadInvoiceFile(file)
        .then((res) =>
          createFee({
            ...feeDetails,
            proof: res?.data?.billUrl,
            feeCollector: feeDetails.feeCollector?.id,
          })
        )
        .then((res) => {
          enqueueSnackbar("Fee collected", { variant: "success" })
          console.log(res.data)
          props.close()
        })
        .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
        .finally(() => setLoading(false))
    } else {
      createFee({
        ...feeDetails,
        amountArray: feeComps,
        feeCollector: feeDetails.feeCollector?.id,
      })
        .then((res) => {
          enqueueSnackbar("Fee collected", { variant: "success" })
          console.log(res.data)
          props.close()
        })
        .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
        .finally(() => setLoading(false))
    }
  }

  const fetchPaymentModes = () => {
    getPaymentModes()
      .then((res) => {
        setPaymentModes(res.data)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
  }

  const [searching2, setSearching2] = useState(false)

  const searchStudents = (value) => {
    findStudents(value)
      .then((res) =>
        setStudents(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching2(false))
  }

  const [studentData, setStudentData] = useState({})

  const getFeeDetails = () => {
    getStudentFee(feeDetails.enrollmentNumber)
      .then((res) => {
        setStudentData(res.data)
        setFeeDetails({
          ...feeDetails,
          name: res.data.user.name,
          year: res.data.admission.year,
          semester: res.data.admission.semester,
          payer: res.data.user.id,
        })
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
  }

  useEffect(() => {
    fetchPaymentModes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      {...props}
      title="Collect Fee"
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Institute Id">
              <TextField
                name="enrollmentNumber"
                value={feeDetails.enrollmentNumber}
                onChange={handleChange}
              />
            </FormItem>
            <Button onClick={getFeeDetails}>Search</Button>
          </Stack>
          <FormItem label="Name">
            <TextField name="name" value={feeDetails.name} disabled />
          </FormItem>

          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Year">
              <TextField name="year" value={feeDetails.year} disabled />
            </FormItem>
            <FormItem label="Semester">
              <TextField name="semester" value={feeDetails.semester} disabled />
            </FormItem>
          </Stack>

          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Payment Mode">
              <Select
                name="modeOfPayment"
                value={feeDetails.modeOfPayment}
                onChange={handleChange}
              >
                {paymentModes.map((type) => (
                  <MenuItem value={type.value}>{type.label}</MenuItem>
                ))}
              </Select>
            </FormItem>
            <FormItem label="Account">
              <Autocomplete
                loading={searching}
                value={feeDetails.accountId}
                onChange={(_, newValue) => {
                  setFeeDetails({
                    ...feeDetails,
                    accountId: newValue?.id,
                  })
                }}
                inputValue={inputAccountValue}
                onInputChange={(_, newInputValue) => {
                  setInputAccountValue(newInputValue)
                  searchStudentsAccounts(newInputValue)
                }}
                getOptionLabel={(option) =>
                  option.accountName + " - " + option.type
                }
                options={studentsAcc}
                renderInput={(params) => <TextField {...params} />}
              />
            </FormItem>
          </Stack>

          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Payment date">
              <DatePicker
                name="paymentDate"
                value={feeDetails.paymentDate}
                onChange={(date) =>
                  setFeeDetails({
                    ...feeDetails,
                    paymentDate: date,
                  })
                }
              />
            </FormItem>
            <FormItem label="Paid To">
              <Autocomplete
                loading={searching2}
                value={feeDetails.feeCollector}
                onChange={(_, newValue) => {
                  setFeeDetails({
                    ...feeDetails,
                    feeCollector: newValue,
                  })
                }}
                inputValue={inputValue}
                onInputChange={(_, newInputValue) => {
                  setInputValue(newInputValue)
                  searchStudents(newInputValue)
                }}
                getOptionLabel={(option) => option.label}
                options={students}
                renderInput={(params) => <TextField {...params} />}
                disabled={true}
              />
            </FormItem>
          </Stack>
          <Stack direction={"row"} justifyContent="space-between" my={2}>
            <Typography variant="h6">Total Fee</Typography>
            <Typography>₹{totalFee}</Typography>
          </Stack>
          <Button
            onClick={() => setAddFeeCompModal(true)}
            variant="contained"
            sx={{ my: 2 }}
          >
            Add Fee Component
          </Button>
          {feeComps && feeComps.length > 0 && (
            <TableComp
              fields={["Fee Head", "Amount", "Discount"]}
              dense
              sx={{ mb: 2 }}
            >
              {feeComps.map((feeComp) => (
                <TableRow>
                  <TableCell>{feeComp.feeHead}</TableCell>
                  <TableCell>₹{feeComp.amount}</TableCell>
                  <TableCell>₹{feeComp.discount}</TableCell>
                </TableRow>
              ))}
            </TableComp>
          )}

          <FormItem label="Attach Proof">
            <DropzoneArea
              filesLimit={1}
              onChange={(e) => setFile(e[0])}
              acceptedFiles={["application/pdf"]}
              useChipsForPreview
            />
          </FormItem>
          <Stack direction={"row"} alignItems="center">
            <FormControlLabel
              onChange={() =>
                setFeeDetails({
                  ...feeDetails,
                  addToRegister: !feeDetails["addToRegister"],
                })
              }
              sx={{ ml: 0 }}
              disabled={expenseAdded}
              name="addToRegister"
              control={<Checkbox checked={feeDetails.addToRegister} />}
              label="Add to Register"
              labelPlacement="start"
            />
          </Stack>
          <Stack direction={"row"} alignItems="center">
            <FormControlLabel
              onChange={() =>
                setFeeDetails({
                  ...feeDetails,
                  generateInvoice: !feeDetails["generateInvoice"],
                })
              }
              disabled={!feeDetails.addToRegister}
              sx={{ ml: 0 }}
              name="generateInvoice"
              control={<Checkbox checked={feeDetails.generateInvoice} />}
              label="Generate Invoice"
              labelPlacement="start"
            />
          </Stack>
          <Stack direction={"row"} alignItems="center">
            <FormControlLabel
              onChange={() =>
                setFeeDetails({
                  ...feeDetails,
                  createExpense: !feeDetails["createExpense"],
                })
              }
              disabled={!feeDetails.addToRegister}
              sx={{ ml: 0 }}
              name="createExpense"
              control={<Checkbox checked={feeDetails.createExpense} />}
              label="Add Expenses"
              labelPlacement="start"
            />
          </Stack>
          {feeDetails["createExpense"] && (
            <>
              <Button
                onClick={() => setAddExpenseModal(true)}
                variant="contained"
                sx={{ my: 2 }}
              >
                Add Expense
              </Button>
              {expenses && expenses.length > 0 && (
                <TableComp
                  fields={["Expense Head", "Amount", "Beneficiary"]}
                  dense
                  sx={{ mb: 2 }}
                >
                  {expenses.map((expense) => (
                    <TableRow>
                      <TableCell>{expense.expenseHead}</TableCell>
                      <TableCell>₹{expense.amount}</TableCell>
                      <TableCell>{expense.beneficiaryName}</TableCell>
                    </TableRow>
                  ))}
                </TableComp>
              )}
            </>
          )}

          {studentData?.admission && (
            <>
              <Stack alignItems={"center"} my={2}>
                <Typography variant="h6">Past Fee Payments</Typography>
              </Stack>
              {studentData?.feePayments &&
              studentData?.feePayments.length > 0 ? (
                <>
                  <TableComp
                    fields={["Date", "Transaction ID", "Amount", "Paid To"]}
                    dense
                    sx={{ mb: 2 }}
                  >
                    {studentData?.feePayments.map((feePayment) => (
                      <TableRow>
                        <TableCell>{feePayment.createdAt}</TableCell>
                        <TableCell>{feePayment.incomeId}</TableCell>
                        <TableCell>₹{feePayment.amount}</TableCell>
                        <TableCell>{feePayment.feeCollector}</TableCell>
                      </TableRow>
                    ))}
                  </TableComp>
                </>
              ) : (
                <>
                  <Stack alignItems={"center"} my={2}>
                    <Typography variant="body2">
                      No Fee Payments done!
                    </Typography>
                  </Stack>
                </>
              )}
              <Stack direction={"row"} justifyContent="space-between">
                <Typography>Total Admission Fee</Typography>
                <Typography>
                  ₹
                  {studentData?.feeSchedule?.reduce(
                    (a, d) => a + d.totalFee,
                    0
                  )}
                </Typography>
              </Stack>
              <Stack direction={"row"} justifyContent="space-between">
                <Typography>Total Fee Collected</Typography>
                <Typography>
                  {" "}
                  ₹
                  {studentData?.feeSchedule?.reduce(
                    (a, d) => a + d.feeCollected,
                    0
                  )}
                </Typography>
              </Stack>
              <Stack direction={"row"} justifyContent="space-between">
                <Typography>Balance</Typography>
                <Typography>
                  ₹
                  {studentData?.feeSchedule?.reduce(
                    (a, d) => a + d.amountDue,
                    0
                  )}
                </Typography>
              </Stack>{" "}
              <Stack direction={"row"} justifyContent="space-between">
                <Typography>Total Amount</Typography>
                <Typography>₹{totalFee}</Typography>
              </Stack>{" "}
              <Stack direction={"row"} justifyContent="space-between">
                <Typography>Final Balance</Typography>
                <Typography>
                  ₹
                  {studentData?.feeSchedule?.reduce(
                    (a, d) => a + d.amountDue,
                    0
                  ) - totalFee}
                </Typography>
              </Stack>{" "}
            </>
          )}
        </Stack>
      </LocalizationProvider>
      <AddFeeCompSingle
        isOpen={addFeeCompModal}
        close={() => setAddFeeCompModal(false)}
        add={(feeComp) => {
          setTotalFee(
            parseFloat(totalFee) +
              parseFloat(feeComp?.amount || 0) -
              parseFloat(feeComp?.discount || 0)
          )
          setFeeComps([...feeComps, feeComp])
        }}
      />
      <AddPayment
        isExpense={true}
        isOpen={addExpenseModal}
        close={() => setAddExpenseModal(false)}
        add={(expense) => {
          setExpenses([...expenses, expense])
        }}
        refresh={() => setExpenseAdded(true)}
      />
    </Modal>
  )
}

export default AddFee
